import { render, staticRenderFns } from "./ApplicationMessage.vue?vue&type=template&id=88e378cc&"
import script from "./ApplicationMessage.vue?vue&type=script&lang=ts&"
export * from "./ApplicationMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VBottomSheet,VBtn,VSheet})
